import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import Disclaimer from 'lib/designSystem/Disclaimer';
import React from 'react';

import { AccountingPeriod } from '../../../types';

interface ClosePeriodDialogProps {
  open: boolean;
  onClose: () => void;
  periodToClose: AccountingPeriod | null;
  closeDate: string;
  onCloseDateChange: (date: string) => void;
  onConfirm: () => void;
}

const ClosePeriodDialog: React.FC<ClosePeriodDialogProps> = ({
  open,
  onClose,
  periodToClose,
  closeDate,
  onCloseDateChange,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmar Cierre de Período</DialogTitle>
      <DialogContent>
        <Box sx={{ padding: 2 }}>
          <Disclaimer
            text={
              <>
                ¿Estás seguro de que quieres cerrar el período{' '}
                <strong>{periodToClose?.label}</strong>?
              </>
            }
          />

          <TextField
            label="Fecha de cierre"
            type="date"
            value={closeDate}
            onChange={(e) => onCloseDateChange(e.target.value)}
            fullWidth
            margin="normal"
            inputProps={{
              min: periodToClose?.startDate?.split('T')[0],
              max: periodToClose?.endDate?.split('T')[0],
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={onClose} color="secondary">
          Cancelar
        </CustomButton>
        <CustomButton onClick={onConfirm} color="primary">
          Confirmar Cierre
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ClosePeriodDialog;
